import { extractJson } from 'wfui-digital-core/es/lib';
export default function extractJsonFromString(menuContext) {
  return extractJson(menuContext).then(function (extractedContext) {
    var _ref = extractedContext || {},
        menuConfig = _ref.menuConfig;

    if (menuConfig.containers) {
      return menuConfig;
    }

    return {
      containers: []
    };
  });
}